import * as tslib_1 from "tslib";
import * as React from 'react';
import { OptionsEditor } from 'owa-options-core';
import { OptionsCheckbox } from 'owa-options-controls';
import { Toggle } from 'office-ui-fabric-react/lib/components/Toggle';
import getStore from '../data/store/store';
import showPeriodicEnabledOptions from '../data/mutators/showPeriodicEnabledOptions';
import showAutomaticReplyEnabledOptions from '../data/mutators/showAutomaticReplyEnabledOptions';
import setBlockCalendarEnabledState from '../data/mutators/setBlockCalendarEnabledState';
import setDeclineNewInvitationsEnabledState from '../data/mutators/setDeclineNewInvitationsEnabledState';
import setSendRepliesToContactsOnlyEnabledState from '../data/mutators/setSendRepliesToContactsOnlyEnabledState';
import setSendRepliesOutsideOrgEnabledState from '../data/mutators/setSendRepliesOutsideOrgEnabledState';
import intializeEditorViewState from '../data/mutators/intializeEditorViewStateMessage';
import intializeEditorViewOutsideOrgState from '../data/mutators/intializeEditorViewOutsideOrgState';
import declineMeetingsSelectedCategory from '../data/mutators/declineMeetingsSelectedCategory';
import setBlockCalendarTitle from '../data/mutators/setBlockCalendarTitle';
import updateCalendarEventSelections from '../data/mutators/updateCalendarEventSelections';
import setDeclineExistingCalendarEvents from '../actions/setDeclineExistingCalendarEvents';
import setEndDate from '../actions/setEndDate';
import setStartDate from '../actions/setStartDate';
import setStartTime from '../actions/setStartTime';
import setEndTime from '../actions/setEndTime';
import { getFallbackValueIfNull } from 'owa-options-core';
import strings from 'owa-strings/owa-options-strings';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import AutomaticRepliesDateRangeSelector from './AutomaticRepliesDateRangeSelector';
import { formatUserDate, formatUserTime } from 'owa-datetime';
import { DetailsList, Selection, ConstrainMode, } from 'office-ui-fabric-react/lib/DetailsList';
import { MarqueeSelection } from 'office-ui-fabric-react/lib/MarqueeSelection';
import { observer } from 'mobx-react';
import DeclineMeetingSelectionState from '../data/store/schema/DeclineMeetingSelectionState';
import { OptionDescription } from 'owa-options-controls';
import { getIsAutomaticReplyEnabled, getPeriodicReplyEnabled, getBlockCalendarEnabled, getDeclineNewInvitationsEnabled, getSendRepliesToContactsOnlyEnabled, getSendRepliesOutsideOrgEnabled, getBlockCalendarTitle, getDeclineMeetingSelectedCategoryKey, } from '../selectors/getStoreProperties';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
var styles = require('./AutomaticRepliesFull.scss');
var listMinWidth = 80;
var listMaxWidth = 80;
var subMinWidth = 150;
var subMaxWidth = 150;
var AutomaticRepliesFull = /** @class */ (function (_super) {
    tslib_1.__extends(AutomaticRepliesFull, _super);
    function AutomaticRepliesFull(props) {
        var _this = _super.call(this, props) || this;
        _this.calendarEventSelection = new Selection({
            onSelectionChanged: _this.onCalendarEventSelected.bind(_this),
        });
        _this.onStartDateSelection = _this.onStartDateSelection.bind(_this);
        _this.onEndDateSelection = _this.onEndDateSelection.bind(_this);
        _this.onStartTimeChanged = _this.onStartTimeChanged.bind(_this);
        _this.onEndTimeChanged = _this.onEndTimeChanged.bind(_this);
        _this.toggleDeclineExistingInvitations = _this.toggleDeclineExistingInvitations.bind(_this);
        return _this;
    }
    AutomaticRepliesFull.prototype.render = function () {
        var optionStore = getStore().currentState;
        var isEnterpriseUser = !isConsumer();
        var isAutomaticReplyEnabled = getIsAutomaticReplyEnabled();
        var periodicReplyEnabled = getPeriodicReplyEnabled();
        var blockCalendarEnabled = getBlockCalendarEnabled();
        var declineNewInvitationsEnabled = getDeclineNewInvitationsEnabled();
        var sendOnlyToContacts = getSendRepliesToContactsOnlyEnabled();
        var sendRepliesOutsideOrg = getSendRepliesOutsideOrgEnabled();
        var blockCalendarInputTitle = getBlockCalendarTitle();
        var declineMeetingMessageCategories = [
            {
                key: DeclineMeetingSelectionState.UseAutomaticReplyMessage,
                text: strings.options_automaticReplies_emailReplies_messageSelect_myMessage,
            },
            {
                key: DeclineMeetingSelectionState.CreateNewMessage,
                text: strings.options_automaticReplies_emailReplies_messageSelect_createMessage,
            },
        ];
        var declineMeetingSelectedCategoryKey = getDeclineMeetingSelectedCategoryKey();
        var declineExistingCalendarEventsEnabled = getFallbackValueIfNull(optionStore.declineExistingCalendarEventsEnabled, false // not considering the value from server.
        );
        var declineMeetingCustomMessageEnabled = getFallbackValueIfNull(declineMeetingSelectedCategoryKey == DeclineMeetingSelectionState.CreateNewMessage, false);
        return (React.createElement("div", null,
            React.createElement(OptionDescription, null, strings.options_automaticReplies_emailReplies),
            React.createElement("div", { className: styles.showAutoReplyOptions },
                React.createElement(Toggle, { checked: isAutomaticReplyEnabled, onText: strings.options_automaticReplies_emailReplies_turnOffAutomaticReplies, offText: strings.options_automaticReplies_emailReplies_turnOnAutomaticReplies, className: styles.toggle, onChanged: this.toggleAutomaticReply })),
            React.createElement(OptionsCheckbox, { checked: periodicReplyEnabled, label: strings.options_automaticReplies_emailReplies_sendInTimePeriod, onChange: this.togglePeriodicReply, disabled: !isAutomaticReplyEnabled }),
            React.createElement("div", { className: styles.showAutoReplyOptions },
                React.createElement(AutomaticRepliesDateRangeSelector, { isEnabled: isAutomaticReplyEnabled && periodicReplyEnabled, onStartDateSelection: this.onStartDateSelection, onEndDateSelection: this.onEndDateSelection, onStartTimeChanged: this.onStartTimeChanged, onEndTimeChanged: this.onEndTimeChanged }),
                React.createElement("div", { className: styles.showPeriodicReplyOptions }, isAutomaticReplyEnabled &&
                    periodicReplyEnabled && [
                    React.createElement(OptionsCheckbox, { key: "block_calendar_checkbox", checked: blockCalendarEnabled, label: strings.options_automaticReplies_emailReplies_blockCalendar, onChange: this.toggleBlockCalendar }),
                    React.createElement("div", { key: "block_calendar_suboptions" }, blockCalendarEnabled && (React.createElement("div", null,
                        React.createElement(TextField, { className: styles.blockCalendarInput, value: blockCalendarInputTitle, onChanged: this.onBlockCalendarTitleChanged, disabled: !blockCalendarEnabled, placeholder: strings.options_automaticReplies_emailReplies_blockTitle })))),
                    React.createElement(OptionsCheckbox, { key: "decline_new_invitations", checked: declineNewInvitationsEnabled, label: strings.options_automaticReplies_emailReplies_automaticDecline, onChange: this.toggleDeclineNewInvitations }),
                    React.createElement(OptionsCheckbox, { key: "decline_existing_invitations", checked: declineExistingCalendarEventsEnabled, label: strings.options_automaticReplies_emailReplies_declineAndCancel, onChange: this.toggleDeclineExistingInvitations }),
                    React.createElement("div", { key: "calendar_events_list" }, optionStore.calendarViewItems &&
                        optionStore.calendarViewItems.length > 0 &&
                        declineExistingCalendarEventsEnabled && (React.createElement("div", { className: styles.declineExistingMeetings },
                        React.createElement(Label, null, strings.options_automaticReplies_emailReplies_cancel_meetings_select_message),
                        React.createElement(Dropdown, { selectedKey: declineMeetingSelectedCategoryKey, options: declineMeetingMessageCategories, className: styles.dropDown, onChanged: this.onDeclineMeetingSeletedCategoryChanged }),
                        React.createElement("div", null, declineMeetingCustomMessageEnabled &&
                            isAutomaticReplyEnabled && (React.createElement(OptionsEditor, { editorViewState: optionStore.editorViewStateDeclineMeeting, ribbonViewState: optionStore.ribbon, initialize: intializeEditorViewState, watermark: strings.options_automaticReplies_emailReplies_optionsEditor_watermark }))),
                        React.createElement(Label, null, strings.options_automaticReplies_emailReplies_selectClearEvents),
                        React.createElement(MarqueeSelection, { selection: this.calendarEventSelection },
                            React.createElement(DetailsList, { items: optionStore.calendarViewItems, columns: this.buildCalendarEventsColumns(optionStore.calendarViewItems), selection: this.calendarEventSelection, onRenderItemColumn: this.onRenderItemColumn, constrainMode: ConstrainMode.horizontalConstrained, className: styles.rootIsHorizontalConstrained }))))),
                ])),
            React.createElement("div", null, isAutomaticReplyEnabled &&
                isEnterpriseUser && (React.createElement("div", { className: styles.sendAutomaticRepliesInOrgText },
                React.createElement(Label, null, strings.options_automaticReplies_emailEnterpriseReplies_sendAutomaticInOrg)))),
            isAutomaticReplyEnabled && (React.createElement(OptionsEditor, { editorViewState: optionStore.editorViewStateMessage, ribbonViewState: optionStore.ribbon, initialize: intializeEditorViewState, watermark: strings.options_automaticReplies_emailReplies_optionsEditor_watermark })),
            React.createElement("div", { className: styles.showAutoReplyOptions },
                isEnterpriseUser && (React.createElement(OptionsCheckbox, { checked: sendRepliesOutsideOrg, label: strings.options_automaticReplies_emailEnterpriseReplies_sendAutomaticOutOrg, onChange: this.toggleSendRepliesOutsideOrg, disabled: !isAutomaticReplyEnabled })),
                React.createElement(OptionsCheckbox, { checked: sendOnlyToContacts, label: strings.options_automaticReplies_emailReplies_sendOnlyToContacts, onChange: this.toggleSendRepliesOnlytoContacts, className: isEnterpriseUser && styles.sendOnlyToContacts, disabled: !isAutomaticReplyEnabled ||
                        (isEnterpriseUser && !sendRepliesOutsideOrg) }),
                isEnterpriseUser &&
                    sendRepliesOutsideOrg &&
                    isAutomaticReplyEnabled && (React.createElement(OptionsEditor, { editorViewState: optionStore.editorViewStateOutsideOrg, ribbonViewState: optionStore.ribbon, initialize: intializeEditorViewOutsideOrgState, watermark: strings.options_automaticReplies_emailReplies_optionsEditor_watermark })))));
    };
    /**
     * Handler for toggling periodic replies status
     * @param {React.FormEvent<HTMLElement | HTMLInputElement>} ev form event
     * @param {boolean} checked checked status
     */
    AutomaticRepliesFull.prototype.togglePeriodicReply = function (ev, checked) {
        showPeriodicEnabledOptions(checked);
    };
    /**
     * Handler for toggling automatic replies status
     * @param {boolean} checked checked status
     */
    AutomaticRepliesFull.prototype.toggleAutomaticReply = function (checked) {
        showAutomaticReplyEnabledOptions(checked);
    };
    /**
     * Handler for toggling block calendar status
     * @param {React.FormEvent<HTMLElement | HTMLInputElement>} ev form event
     * @param {boolean} checked checked status
     */
    AutomaticRepliesFull.prototype.toggleBlockCalendar = function (ev, checked) {
        setBlockCalendarEnabledState(checked);
    };
    /**
     * Handler for toggling decline new invitations status
     * @param {React.FormEvent<HTMLElement | HTMLInputElement>} ev form event
     * @param {boolean} checked checked status
     */
    AutomaticRepliesFull.prototype.toggleDeclineNewInvitations = function (ev, checked) {
        setDeclineNewInvitationsEnabledState(checked);
    };
    /**
     * Handler for toggling send replies only to contact status
     * @param {React.FormEvent<HTMLElement | HTMLInputElement>} ev form event
     * @param {boolean} checked checked status
     */
    AutomaticRepliesFull.prototype.toggleSendRepliesOnlytoContacts = function (ev, checked) {
        setSendRepliesToContactsOnlyEnabledState(checked);
    };
    /**
     * Handler for toggling send replies outside org status
     * @param {React.FormEvent<HTMLElement | HTMLInputElement>} ev form event
     * @param {boolean} checked checked status
     */
    AutomaticRepliesFull.prototype.toggleSendRepliesOutsideOrg = function (ev, checked) {
        setSendRepliesOutsideOrgEnabledState(checked);
    };
    /**
     * Handler for toggling decline existing invitations status
     * @param {React.FormEvent<HTMLElement | HTMLInputElement>} ev form event
     * @param {boolean} checked checked status
     */
    AutomaticRepliesFull.prototype.toggleDeclineExistingInvitations = function (ev, checked) {
        setDeclineExistingCalendarEvents(checked);
        this.calendarEventSelection.setAllSelected(false);
    };
    /**
     * Handler for changing block calendar title
     * @param {string} text new changed text
     */
    AutomaticRepliesFull.prototype.onBlockCalendarTitleChanged = function (text) {
        setBlockCalendarTitle(text);
    };
    /**
     * Handler for changing start date
     * @param {DisplayDate} date new start date
     */
    AutomaticRepliesFull.prototype.onStartDateSelection = function (date) {
        setStartDate(date);
        this.calendarEventSelection.setAllSelected(false);
    };
    /**
     * Handler for changing end date
     * @param {DisplayDate} date new end date
     */
    AutomaticRepliesFull.prototype.onEndDateSelection = function (date) {
        setEndDate(date);
        this.calendarEventSelection.setAllSelected(false);
    };
    /**
     * Utility method to build the calendar event columns
     * @param {CalendarEvent[]} items calendar events
     */
    AutomaticRepliesFull.prototype.buildCalendarEventsColumns = function (items) {
        var columns = [];
        var displayFields = [
            strings.options_automaticReplies_emailReplies_cancel_meetings_subject_header,
            strings.options_automaticReplies_emailReplies_cancel_meetings_organiser_header,
            strings.options_automaticReplies_emailReplies_cancel_meetings_startTime_header,
            strings.options_automaticReplies_emailReplies_cancel_meetings_endTime_header,
        ];
        var displayKeys = ['Subject', 'Organizer', 'Start', 'End'];
        displayKeys.map(function (k, i) {
            columns[i] = {
                key: displayKeys[i],
                fieldName: null,
                name: displayFields[i],
                minWidth: displayKeys[i] === 'Subject' ? subMinWidth : listMinWidth,
                maxWidth: displayKeys[i] === 'Subject' ? subMaxWidth : listMaxWidth,
                isResizable: true,
            };
        });
        return columns;
    };
    /**
     * Handler invoked when calendar event is selected
     */
    AutomaticRepliesFull.prototype.onCalendarEventSelected = function () {
        var selections = this.calendarEventSelection.getSelection();
        var selectionIds = selections.map(function (item) {
            return item.ItemId.Id;
        });
        updateCalendarEventSelections(selectionIds);
    };
    /**
     * Handler when start time is changed
     * @param {DisplayDate} date new start date
     */
    AutomaticRepliesFull.prototype.onStartTimeChanged = function (date) {
        setStartTime(date);
        this.calendarEventSelection.setAllSelected(false);
    };
    /**
     * Handler when end time is changed
     * @param {DisplayDate} date new end date
     */
    AutomaticRepliesFull.prototype.onEndTimeChanged = function (date) {
        setEndTime(date);
        this.calendarEventSelection.setAllSelected(false);
    };
    /**
     * Handler when decline meeting message category is changed
     * @param {IDropdownOption} option new selected option
     */
    AutomaticRepliesFull.prototype.onDeclineMeetingSeletedCategoryChanged = function (option) {
        declineMeetingsSelectedCategory(option.key);
    };
    /**
     * Handler for rendering column
     * @param item to render in details list
     * @param {number} index of item
     * @param {IColumn} column in list
     */
    AutomaticRepliesFull.prototype.onRenderItemColumn = function (item, index, column) {
        if (column.key === 'Organizer') {
            var organizer = item[column.key];
            if (organizer && organizer.Mailbox) {
                return organizer.Mailbox.Name;
            }
        }
        if (column.key === 'Start' || column.key === 'End') {
            var date = item[column.key];
            return formatUserDate(date) + ' ' + formatUserTime(date);
        }
        return item[column.key];
    };
    AutomaticRepliesFull = tslib_1.__decorate([
        observer
    ], AutomaticRepliesFull);
    return AutomaticRepliesFull;
}(React.Component));
export default AutomaticRepliesFull;
//# sourceMappingURL=AutomaticRepliesFull.js.map